import { create } from 'zustand';

type View =
  | 'dashboard'
  | 'patients'
  | 'patient-details'
  | 'records'
  | 'record-details'
  | 'schedule'
  | 'appointment-details'
  | 'add-patient'
  | 'add-appointment'
  | 'add-record'
  | 'settings'
  | 'lab-orders'
  | 'lab-order-details'
  | 'new-lab-order'
  | 'adt'
  | 'templates'
  | 'billing'
  | 'reports'
  | 'admin-users'
  | 'admin-roles'
  | 'admin-system-settings'
  | 'admin-system-monitoring'
  | 'admin-audit-logs'
  | 'resource-scheduling'
  | 'provider-availability'
  | 'waitlist-management'
  | 'order-management'
  | 'pharmacy'
  | 'coding'
  | 'census'
  | 'templates'
  | 'admin-dashboard'
  | 'admin-users'
  | 'admin-roles'
  | 'admin-system-settings'
  | 'admin-system-monitoring'
  | 'admin-audit-logs'
  | 'settings'
  | 'test';

interface NavigationStore {
  activeView: View;
  viewParams: Record<string, unknown>;
  setActiveView: (view: View, params?: Record<string, unknown>) => void;
}

export const useNavigationStore = create<NavigationStore>((set) => ({
  activeView: 'dashboard',
  viewParams: {},
  setActiveView: (view, params = {}) => set({ activeView: view, viewParams: params })
}));